import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardNavbar from '../components/layout/DashboardNavbar';

const ScoutLayout = () => {
  return (
    <div className="min-h-screen bg-common-gradient">
      {/* Navbar */}
      <DashboardNavbar userRole="scout" />

      {/* Page Content */}
      <div className="pt-16 sm:pt-20 p-6">
        <Outlet />
      </div>
    </div>
  );
};

export { ScoutLayout };
export default ScoutLayout;
